export const GTM_CLASSNAMES = {
	REVIEW_TAB_VERIFIED: "review-tab-verified",
	REVIEW_TAB_GOOGLE: "review-tab-google",
	DROPDOWN_ITEM_AMENITIES: "dropdown-item-amenities",
	DROPDOWN_ITEM_UNIT_SIZES: "dropdown-item-unit-sizes",
	DROPDOWN_ITEM_VEHICLE_STORAGE: "dropdown-item-vehicle-storage",

	// search/landing page GTM tracking
	FACILITY_CARD_VIEW_ALL_UNITS: "gtm-facility-card-view-all-units",
	// Only wired up for markerType="overlay" (MapPin doesn't accept className)
	SEARCH_MAP_PIN: "gtm-search-map-pin",
	SORT_SELECT: "gtm-results-sort-select"
};
